import { createSlice } from "@reduxjs/toolkit";

const origenesState = {
  origenesdata: {},
};

const origenesSlice = createSlice({
  name: "origenes",
  initialState: origenesState,
  reducers: {
    origenesData: (state, actions) => actions.payload,
    limpiarOrigenesData: () => origenesState,
  },
});

export const { origenesData, limpiarOrigenesData } = origenesSlice.actions;

export default origenesSlice.reducer;